import { useTheme } from '@mui/material/styles';
import { useCallback } from 'react';

var getThemeColor = function (theme, color) {
    if (theme && color in theme.palette) {
        var paletteColor = theme.palette[color];
        if (paletteColor && typeof paletteColor === 'object') {
            if ('main' in paletteColor) {
                return paletteColor.main;
            }
            if ('500' in paletteColor) {
                return paletteColor[500];
            }
        }
    }
    return color;
};
var useThemeColor = function () {
    var theme = useTheme();
    return useCallback(function (color) {
        return getThemeColor(theme, color);
    }, [theme]);
};

export { useThemeColor };
//# sourceMappingURL=useThemeColor.js.map
